import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'Manufacturing & Distribution', href: '/manufacturing-and-distribution' },
  { label: 'Products & Services', href: '/products-and-services' },
  { label: 'Contact Us', href: '/contact-us' },
];

export default function Footer() {
  return (
    <footer style={{ background: '#002868' }}>
      <div className="max-w-7xl mx-auto px-8 py-14 grid md:grid-cols-3 gap-12">
        {/* Brand */}
        <div>
          <img
            src="https://storage.readdy-site.link/project_files/ef2cd86a-0c8c-43d9-a80f-76980d5cdfeb/efd1c1b3-eb7c-4977-9e9d-97ff5b41d004_OnPoint-Logo-Red-White-and-Blue.png?v=a3ea8d6e61ccf94fd7ba238e66b5c0b3"
            alt="OnPoint USA"
            className="h-10 w-auto mb-4"
          />
          <p className="text-blue-200 text-xs leading-relaxed max-w-xs">
            10 years of trusted expertise and connections in the Regenerative Medicine field. Your success is our mission.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-bold text-base mb-6">Quick Links</h4>
          <ul className="space-y-3">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.href}
                  className="text-blue-200 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-arrow-right-s-line text-red-400" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-white font-bold text-base mb-6">Contact Info</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-2-fill text-red-400" />
              </div>
              <span className="text-blue-200 text-sm leading-relaxed">
                1414 Shore District Dr Ste 3101<br />Austin, TX 78741
              </span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-fill text-red-400" />
              </div>
              <a
                href="mailto:gabriel@onpointlabservices.com"
                className="text-blue-200 text-sm hover:text-white transition-colors"
              >
                gabriel@onpointlabservices.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ background: '#001a4d' }} className="px-8 py-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-blue-300 text-xs">
            2026 &copy; All rights reserved by <strong className="text-white">OnPoint USA</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}
